// extracted by mini-css-extract-plugin
module.exports = {"root":"FlatButton_root__buKkE","isActive":"FlatButton_isActive__28Ud8"};